/* eslint-disable eqeqeq */
import {
  Box,
  Button,
  Link,
  LinkBox,
  LinkOverlay,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import Hamburger from "hamburger-react";
import React from "react";
import { AiFillYoutube, IoCall } from "react-icons/all";
import { Input } from "semantic-ui-react";
import "./App.scss";
import Booking from "./Booking/BookingNew";
import "./Common.css";
import {
  ActionType,
  AdminChecklistItems,
  ICustomerRewardDataResp,
  myReferals,
  progess,
  redeemProduct,
} from "./CommonProps";
import { Common } from "./CommonService";
import Estimate from "./Estimate/Estimate";
import EstimateFeedback from "./EstimateFeedback/EstimateFeedback";
import FlowGetter from "./FlowGetter/FlowGetter";
import LoaderCommon from "./Loader/LoaderCommon";
import Login from "./Login/Login";
import { MessageBoard } from "./MessageBoard/Messageboard";
import { JobSheet } from "./modals/JobSheet";
import { RepairTracker } from "./RepairTracker/RepairTracker";
import { isAdminLogin } from "./Services/AdminService";
import { Steps } from "./shared/data/repairTracker";
import { StampedService } from "./StampedService";
import { IBodyshopService } from "./UserService";

import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from "@chakra-ui/react";
import { IoIosChatbubbles } from "react-icons/io";
import ContactUs from "./ContactUs/contactUs";
import { Activities } from "./modals/Activities";
import { CurrentUser, UserJob } from "./modals/CurrentUser";
import { dashboardTabs } from "./modals/Enums/DashboardTabs";
import { screens } from "./modals/Enums/Screens";
import { JobEstimationDetail } from "./modals/JobEstimationDetail";
import { NotesSuggestion } from "./modals/NotesSuggestion";
import { AppState } from "./modals/StateInterface/AppState";
import Report from "./Report/report";
import SelectJob from "./SelectJob/SelectJob";
import APIService from "./Services/APIService";
import { CommonMethodService } from "./Services/CommonMethodService";
import { IBSAdonisService } from "./Services/IBSAdonisService";
import { Mixpanel } from "./Services/MixPanel";

import { NotifyService } from "./Services/NotifyService";
import SetupPassword from "./SetupPassword/SetUpPassword";
import withNavigate from "./shared/hooks/navigate";
import Dashboard from "./pages/dashboard/dashboard";
import BookInspection from "./Booking/BookInspection";
import { toast } from "react-toastify";
const _flowLogo = require("./assets/images/Fav.png").default;

require("dotenv").config();

export interface AppProps {
  navigate: (path: string, options?: { replace?: boolean }) => void;
}

class App extends React.Component<AppProps, AppState> {
  private pubKey = "pubkey-CvQ0owDug22j4l87Du499p4EsW3dVC";
  private privateKey = "key-58hz34CN4yIi1bRPT60suF9L63EN2s";
  private storeHash = "227954";
  private ibsService = new IBodyshopService();
  private apiService = new APIService();
  private ibsAdonisService = new IBSAdonisService();
  notifyService = new NotifyService();
  private stampedService = new StampedService(
    this.pubKey,
    this.privateKey,
    this.storeHash
  );
  private commonMethodService = new CommonMethodService();

  common = new Common();

  isBookingActionRequired = false;

  isEstimateVisible = false;
  selectedScreen: any = {};
  isAdmin: boolean = false;

  constructor(props: AppProps) {
    super(props);
    this.state = {
      redeemProducts: [],
      images: [],
      showLoader: false,
      isUpdateRenderingCount: 0, // for component did update
      dashboardSelectedTab: "",
      selectedScreen: "",
      showMenu: false,
      showMessageBoard: false,
      allUsers: [],
      currProgress: {
        image: null,
        status: null,
        detail: null,
        video: "",
        isZero: false,
        percent: 0,
        label: "",
      },
      isOwnerExistInStamped: false,
      isOwnerSubscribedInStamped: false,
      isStampedCustomerChecked: false,
      customerReferals: [],
      searchText: "",
      stepItems: "",
      hamburgerColor: "#FFFFFF",
      activeButton: 0,
      report: null,
      currentUserIbsService: null,
      isAdmin: false,
      estimateDetails: null,
      isSetupPasswordDialog: false,
      notesSuggestions: [],
      isChatOpen: false,
      messageBoard: React.createRef(),
      newMessage: false,
      isBookingDetailCompleted: false,
      skipWelcomeFlow: false,
    };
  }

  async fetchNotesSuggestion() {
    const params = CommonMethodService.params();
    if (params["estimateid"]) {
      try {
        const res: NotesSuggestion[] =
          await this.ibsAdonisService.getNoteSuggestion();
        if (res) {
          this.setState({ notesSuggestions: res?.length > 0 ? res : [] });
        } else {
          this.setState({ notesSuggestions: [] });
        }
      } catch (ex) {
        this.setState({ notesSuggestions: [] });
      }
    }
  }

  populateScreen() {
    const { navigate } = this.props;
    const params = CommonMethodService.params();
    this.ibsService.currentUser =
      this.commonMethodService.getDataFromStorage("currentUser");
    this.selectedScreen = this.getDefaultScreen();
    this.isAdmin = isAdminLogin();
    if (!this.ibsService.currentUser || this.isAdmin) {
      if (this.isAdmin) {
        this.setState({ isAdmin: this.isAdmin });
        this.selectedScreen.main = screens.home;
        this.ibsService.loggedIn = true;
        if (params["estimateid"]) {
          this.setState({
            searchText: params["estimateid"],
            isAdmin: this.isAdmin,
          });
          setTimeout(() => {
            this.searchEstimate(true);
          }, 300);
        } else {
          this.commonMethodService.removeAllQueryParams();
        }
      } else {
        this.ibsService.logout();
        this.selectedScreen.main = screens.login;
        this.selectedScreen.second = "";
      }
    } else {
      if (params["estimateid"]) {
        this.fetchNotesSuggestion();
        this.getEstimateDetailsById(false, false);
      } else {
        if (params["step"] === "contactus") {
          this.selectedScreen.main = screens.contactUs;
          this.selectedScreen.second = dashboardTabs.home;
        } else {
          const jobs = this.ibsService.currentUser.user.userJob;
          if (jobs.length === 1) {
            this.ibsAdonisService
              .getJobEstimateDetailsById(jobs[0].external_id)
              .then((res: any) => {
                const isOnBoardingFlow = res.adminCheckList.some(
                  (checklistItem: string) =>
                    checklistItem.includes(AdminChecklistItems.ONBOARDING_FLOW)
                );
                const isBookingFlow = res.adminCheckList.some(
                  (checklistItem: string) =>
                    checklistItem.includes(AdminChecklistItems.BOOKING_FLOW)
                );
                if (isOnBoardingFlow && !isBookingFlow && !res.isCancelled) {
                  if (this.state.skipWelcomeFlow) {
                    navigate(
                      `/?estimateid=${jobs[0].external_id}&step=${screens.bookingInspection}`,
                      {
                        replace: true,
                      }
                    );
                  } else {
                    navigate(`/${jobs[0].external_id}/welcome`, {
                      replace: true,
                    });
                  }
                } else {
                  this.commonMethodService.setQueryParams(
                    jobs[0].external_id,
                    "home"
                  );
                }
              });
          } else {
            this.selectedScreen.main = screens.selectJob;
            this.setState({ selectedScreen: this.selectedScreen.main });
          }
        }
      }
      this.ibsService.loggedIn = true;
      // this.getImages();
    }
  }

  public clearState() {
    this.setState({
      redeemProducts: [],
      images: [],
      showLoader: false,
      dashboardSelectedTab: "home",
      selectedScreen: "login",
      showMenu: false,
      showMessageBoard: false,
      allUsers: [],
      currProgress: {
        image: null,
        status: null,
        detail: null,
        video: "",
        isZero: false,
        percent: 0,
        label: "",
      },
      isOwnerExistInStamped: false,
      isOwnerSubscribedInStamped: false,
      isStampedCustomerChecked: false,
      customerReferals: [], //this.getReferals(5)
      searchText: "",
      stepItems: "",
      hamburgerColor: "#FFFFFF",
      activeButton: 0,
      report: null,
      currentUserIbsService: null,
      isAdmin: false,
      estimateDetails: null,
      isSetupPasswordDialog: false,
      notesSuggestions: [],
      newMessage: false,
    });
  }

  async componentDidMount() {
    const params = CommonMethodService.params();
    if(params["token"]){
      this.ibsService.logout()
    }
    this.populateScreen();
    this.setState({
      dashboardSelectedTab: this.selectedScreen.second,
      selectedScreen: this.selectedScreen.main,
      currentUserIbsService: this.ibsService,
      isAdmin: this.isAdmin,
    });
    if (this.ibsService?.currentUser) {
      await this.getUnRegisteredEstimate();
      await this.getRedeemProducts();
    }
  }

  async componentDidUpdate(_: AppProps, prevState: AppState) {
    const params = CommonMethodService.params();
    const { currentUser } = this.ibsService;

    // Check if conditions are met for updating state and fetching estimate details
    if (
      params["estimateid"] &&
      prevState.selectedScreen === screens.selectJob &&
      prevState.dashboardSelectedTab === "" &&
      prevState.isUpdateRenderingCount === 0 &&
      this.state.isUpdateRenderingCount === 0
    ) {
      this.setState({ isUpdateRenderingCount: 1, showLoader: true });
      try {
        // Fetch job estimate details
        const estimateDetail: JobEstimationDetail =
          await this.ibsAdonisService.getJobEstimateDetailsById(
            params["estimateid"],
            currentUser.auth?.token
          );
        // If details are fetched, update state accordingly
        if (estimateDetail) {
          this.setState({
            estimateDetails: estimateDetail,
            selectedScreen: screens.home,
            dashboardSelectedTab:
              params["step"] === "booking"
                ? screens.booking
                : screens.bookingInspection,
          });
        }
      } catch (error) {
        toast({
          title: "",
          description: "Error fetching job estimate details:",
          error,
          status: "error",
          duration: 1500,
          isClosable: true,
        });
      } finally {
        // Hide loader in both success and failure cases
        this.showHideLoader(false);
      }
    }
  }

  async getUnRegisteredEstimate() {
    const params = CommonMethodService.params();
    const estimateId = params["estimateid"];
    if (estimateId) {
      const isExist = this.ibsService?.currentUser?.user?.userJob?.find(
        (est: UserJob) => est.external_id === estimateId
      );

      if (!isExist) {
        const resp = await this.getEstimateData(params["estimateid"]);
        if (this.ibsService?.currentUser?.user) {
          if (
            resp &&
            (resp.customer.email === this.ibsService.currentUser.user.email || resp.customer.phone === this.ibsService.currentUser.user.phone)
          ) {
            await this.getCustomerData(resp);
          }
        }
      }
    }
  }

  async getRedeemProducts() {
    try {
      const res = await this.ibsAdonisService.searchEstimate("RedeemProduct");
      if (res?.length > 0 && res[0]?.items?.length > 0) {
        const estimates = res[0].items;
        const redeemProductsArray: redeemProduct[] = estimates.map(
          (e: any): redeemProduct => ({
            displayAsField: e.ownerDisplayName,
            contactNotes: "Coming Soon",
            refNo: "RedeemProduct",
            sumInsured: 500,
            total: e.totalAmount,
            estimateId: e.id,
            primaryDetailsId: e.primaryDetailId,
          })
        );
        this.setState({ redeemProducts: redeemProductsArray });
      } else {
        this.setState({ redeemProducts: [] });
      }
    } catch (error) {
      console.error("Error occurred while fetching redeem products:", error);

      // Optionally, update state to handle error scenarios gracefully in the UI
      this.setState({ redeemProducts: [] });
    }
  }

  async getMyReferals(refCode: string) {
    try {
      const res = await this.ibsAdonisService.searchJobEstimate(refCode);
      if (res?.length > 0) {
        const data: myReferals[] = res.map(
          (element): myReferals => ({
            email: element.mobilePhone,
            name: element.ownerName,
            points: element.estimateNumber,
            status: this.common.getReferalStatus(element),
          })
        );
        this.setState({ customerReferals: data });
      }
    } catch (error) {
      console.error("🚀 ~ getMyReferals Error:", error);
    }
  }

  getDefaultScreen() {
    const params = CommonMethodService.params();
    let screen: string = screens.login;
    let tab: string = "";
    if (params["estimateid"]) {
      if (params["step"]) {
        switch (params["step"]) {
          case "booking":
            screen = screens.home;
            tab = dashboardTabs.bookingDetail;
            break;
          case "booking-inspection":
            screen = screens.home;
            tab = dashboardTabs.bookingInspection;
            break;
          case "estimate":
            screen = screens.home;
            tab = dashboardTabs.estimateDetails;
            break;
          case "repairtracker":
            screen = screens.home;
            tab = dashboardTabs.repairTracker;
            break;
          case "report":
            screen = screens.home;
            tab = dashboardTabs.report;
            break;
          case "home":
            screen = screens.home;
            tab = dashboardTabs.home;
            break;
          default:
            this.commonMethodService.removeSingleQueryParams("step");
            screen = screens.home;
            tab = dashboardTabs.home;
            break;
        }
      } else {
        if (params["step"] === "contactUs") {
          screen = screens.contactUs;
          tab = dashboardTabs.home;
        } else {
          this.commonMethodService.removeSingleQueryParams("step");
          screen = screens.home;
          tab = "";
        }
      }
    } else {
      if (params["step"] === "contactus") {
        screen = screens.contactUs;
        tab = dashboardTabs.home;
      } else {
        this.commonMethodService.removeAllQueryParams();
      }
    }
    return { main: screen, second: tab };
  }

  // Commented by Usman
  /* getImages() {
    if (!this.ibsService.currentUser?.user) {
      return null;
    }

    let estID = this.ibsService.currentUser.user.external_id as string;
    this.ibsService.getImageList(estID).then((res) => {
      if (res.ok) {
        res.json().then((resJSON: ImagesListEntity[]) => {
          if (resJSON.length > 0) {
            this.setState({
              images: resJSON[0].images.filter((x) => !x.isArchived),
            });
          }
        });
      }
    });
  } */


  async handleActionLogsAndNavigation(res: any, estimateNumber: string) {
    const { navigate } = this.props;
    const actionLogsResponse = await this.apiService.getActionLogs(
      res?.estimateId,
      ActionType.DirectBookingInspectionCheck
    );
    const actionLogs = await actionLogsResponse.json();
    if (actionLogs?.length) {
      const isUserActivated = Boolean(actionLogs[0]?.is_used);
      if (!isUserActivated) {
        await this.apiService.markActionLogAsUsed({
          estimateNumber: estimateNumber,
          action: ActionType.DirectBookingInspectionCheck,
        });
        this.setState({
          estimateDetails: res,
          skipWelcomeFlow: true,
          selectedScreen: screens.home,
          dashboardSelectedTab: screens.bookingInspection,
        });
        navigate(
          `/?estimateid=${estimateNumber}&step=${screens.bookingInspection}`,
          {
            replace: true,
          }
        );
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  async getEstimateDetailsById(
    isFromAccept: boolean,
    isFirstTime: boolean,
    estimateId?: any,
    type?: string,
    showLoader?: boolean
  ) {
    const { navigate } = this.props;
    const params = CommonMethodService.params();
    if (!this.ibsService.currentUser?.user && !this.state.isAdmin) {
      return null;
    }

    if (showLoader === undefined || showLoader) this.showHideLoader(true);

    let estID = "";
    if (params["estimateid"]) {
      estID = params["estimateid"];
    } else if (estimateId) {
      estID = estimateId;
    } else if (
      type === "selectJob" &&
      this.ibsService?.currentUser?.user?.external_id
    ) {
      estID = this.ibsService?.currentUser?.user?.external_id as string;
    }
    if (estID) {
      try {
        let data: JobEstimationDetail =
          await this.ibsAdonisService.getJobEstimateDetailsById(
            estID,
            this.ibsService.currentUser?.auth?.token
          );

        if (data && Object.keys(data).length > 0) {
          this.commonMethodService.setDataIntoStorage("estimateData", data)
          const isOnBoardingFlow = data.adminCheckList.some(
            (checklistItem: string) =>
              checklistItem.includes(AdminChecklistItems.ONBOARDING_FLOW)
          );
          const isBookingFlow = data.adminCheckList.some((checklistItem) =>
            checklistItem.includes(AdminChecklistItems.BOOKING_FLOW)
          );
          const bookingExistRecord =
            await this.ibsAdonisService.fetchInspectionData(
              String(data.estimateNumber)
            );

          if (
            data.email === this.ibsService.currentUser.user.email ||
            this.state.isAdmin
          ) {
            this.isBookingActionRequired =
              !data?.cancelled && data?.jobNumber !== 0;

            if (
              params["step"] &&
              params["step"] === "booking" &&
              !data.isCancelled
            ) {
              if (isOnBoardingFlow && !isBookingFlow) {
                if (this.state.skipWelcomeFlow) {
                  navigate(
                    `/?estimateid=${params["estimateid"]}&step=${screens.bookingInspection}`,
                    {
                      replace: true,
                    }
                  );
                } else {
                  this.commonMethodService.removeAllQueryParams();
                  navigate(`/${params["estimateid"]}/welcome/`);
                }
              } else if (isBookingFlow) {
                this.setState({
                  dashboardSelectedTab: dashboardTabs.bookingDetail,
                });
              } else {
                this.deleteStepFromURL(); //
                this.commonMethodService.setQueryParams(estID, "home");
              }
            } else if (
              params["step"] &&
              params["step"] === "booking-inspection" &&
              !data.isCancelled
            ) {
              this.setState({
                dashboardSelectedTab: dashboardTabs.bookingInspection,
              });
            } else {
              if (
                isOnBoardingFlow &&
                !bookingExistRecord &&
                !params["step"] &&
                !isBookingFlow
              ) {
                if (this.state.skipWelcomeFlow) {
                  navigate(
                    `/?estimateid=${data?.estimateNumber}&step=${screens.bookingInspection}`,
                    {
                      replace: true,
                    }
                  );
                } else {
                  const checkActionLogs =
                    await this.handleActionLogsAndNavigation(
                      data,
                      `${data?.estimateNumber}`
                    );
                  if (!checkActionLogs) {
                    this.commonMethodService.removeAllQueryParams();
                    navigate(`/${data?.estimateNumber}/welcome`, {
                      replace: true,
                    });
                  }
                }
              } else if (!params["step"]) {
                this.deleteStepFromURL();
                this.commonMethodService.setQueryParams(estID, "home");
              }
            }
            await this.setEstimateDetailData(
              data,
              isFromAccept,
              isOnBoardingFlow,
              isBookingFlow
            );
            return data;
          } else {
            this.setOnJobPage();
          }
        } else {
          this.setOnJobPage();
        }
        Mixpanel.track("Get Job", {
          data: data,
          estimateId: estID,
          status: "Data fetched",
        });
      } catch (ex: any) {
        Mixpanel.track("Get Job Error", {
          error: ex,
          estimateId: estID,
          statusText: ex?.statusText ? ex?.statusText : "",
          status: ex?.status ? ex.status : "Something went wrong",
        });

        this.setState({
          estimateDetails: null,
        });
        this.showHideLoader(false);
      }
    } else {
      Mixpanel.track("Get Job Error", {
        estimateId: estID,
        status: "Didn't provide estimateId",
      });
      this.showHideLoader(false);
    }
  }

  setOnJobPage() {
    this.notifyService.errorNotitifcation("Invalid estimate ID.");
    this.commonMethodService.removeAllQueryParams();
    if (!this.state.isAdmin) {
      this.setState({
        selectedScreen: screens.selectJob,
        estimateDetails: null,
      });
    } else {
      this.setState({
        selectedScreen: screens.home,
        estimateDetails: null,
      });
      this.render();
    }

    this.showHideLoader(false);
  }

  setEstimateDetailData = async (
    data: JobEstimationDetail,
    isFromAccept: boolean,
    isOnBoardingFlow?: boolean,
    isBookingFlow?: boolean
  ) => {
    const params = CommonMethodService.params();

    const isOnBoardingFlowCheck = isOnBoardingFlow || false;
    const isBookingFlowCheck = isBookingFlow || false;
    let hasPostCheck = false;
    this.setState({
      estimateDetails: data,
      showLoader: false,
    });

    /*   await this.getReport(
      data.estimateId,
      this.ibsService?.currentUser?.auth?.token
    ); */
    let allTasks = Steps;

    if (data.isVehicleOnSite) {
      allTasks.arrival.stepStatus = "Completed";
    }
    // let Ready, JobUpdate, Precheck;
    if (data.trackables && data.trackables.length > 0) {
      data.trackables
        .filter((x) => ["1PC", "2SC", "7PR"])
        .forEach((ele: any) => {
          if (ele.id == "1PC") {
            allTasks.preCheck.stepStatus = ele.status;
          } else if (ele.id == "2SC") {
            allTasks.suppCheck.stepStatus = ele.status;
          } else if (ele.id == "7PR") {
            if (ele.status === "Completed" || ele.status === "Complete") {
              hasPostCheck = false;
            } else {
              hasPostCheck = true;
            }
            allTasks.postCheck.stepStatus = ele.status;
          }
        });
    }
    let progr: progess = {
      image: null,
      status: null,
      detail: null,
      video: "",
      isZero: false,
      percent: 0,
      label: "",
    };
    // var Detailing, Refit, Paint, Prep, Prime, Repair, Strip;
    if (data.activities && data.activities.length > 0) {
      data.activities.forEach((ele: Activities) => {
        if (ele.name === "Detailing" && allTasks.repair.subTasks?.detail) {
          allTasks.repair.subTasks.detail.stepStatus = ele.status;
        }
        if (ele.name === "Refit" && allTasks.repair.subTasks?.refit) {
          allTasks.repair.subTasks.refit.stepStatus = ele.status;
        }
        if (ele.name === "Paint" && allTasks.repair.subTasks?.paint) {
          allTasks.repair.subTasks.paint.stepStatus = ele.status;
        }
        if (ele.name === "Prep" && allTasks.repair.subTasks?.prep) {
          allTasks.repair.subTasks.prep.stepStatus = ele.status;
        }
        if (ele.name === "Prime" && allTasks.repair.subTasks?.prime) {
          allTasks.repair.subTasks.prime.stepStatus = ele.status;
        }
        if (ele.name === "Repair" && allTasks.repair.subTasks?.repair) {
          allTasks.repair.subTasks.repair.stepStatus = ele.status;
        }
        if (ele.name === "Remove" && allTasks.repair.subTasks?.strip) {
          allTasks.repair.subTasks.strip.stepStatus = ele.status;
        }
      });
    } else {
      progr.status = data.assessmentStatus;
    }
    allTasks.complete.stepStatus =
      data.isCompleted && !hasPostCheck ? "Completed" : "No";

    allTasks.collect.stepStatus =
      data.isVehicleCollected && !hasPostCheck ? "Completed" : "No";

    // New tracker Code

    let filteredTasks: any = {};
    Object.keys(allTasks).forEach((each: string) => {
      if (allTasks[each].stepStatus !== "") {
        filteredTasks[each] = allTasks[each];
      }

      if (allTasks[each].subTasks) {
        const tasks: any = {};
        Object.keys(allTasks[each]?.subTasks)?.forEach((task: any) => {
          if (allTasks[each].subTasks[task].stepStatus !== "")
            tasks[task] = allTasks[each].subTasks[task];
        });

        filteredTasks.repair.subTasks = tasks;

        const complete = Object.keys(tasks).every(
          (element: any) =>
            tasks[element].stepStatus === "Completed" ||
            tasks[element].stepStatus === "Complete"
        );

        if (complete) filteredTasks.repair.stepStatus = "Completed";
        if (
          Array.isArray(data?.productionSummaryId) &&
          data?.productionSummaryId !== undefined
        ) {
          this.setStatusOnHold(data?.productionSummaryId, filteredTasks);
        }
      }
    });
    if (
      data.jobOnHoldHeader &&
      (data.jobOnHoldHeader.onHoldReason || data.jobOnHoldHeader.onHoldUntil)
    ) {
      filteredTasks.repair.onHoldReason = data.jobOnHoldHeader.onHoldReason;
      filteredTasks.repair.onHoldUntil = data.jobOnHoldHeader.onHoldUntil;
    }

    let selScreen;
    if (progr.status === "Ready for Pickup" && data.isVehicleCollected) {
      selScreen = dashboardTabs.estimateFeedback;
    } else if (isFromAccept && !this.common.isEstimateDeclined(data)) {
      // Grouped conditions under `isFromAccept`
      if (isBookingFlowCheck) {
        selScreen = dashboardTabs.bookingDetail;
      } else {
        selScreen = this.state.dashboardSelectedTab;
      }
    } else {
      // Default fallback
      selScreen = this.state.dashboardSelectedTab;
    }

    if (this.ibsService.isLinkOpenedFromEmail) {
      if (!data.jobBookingId) data.repairDaysRequired = 2;
    }

    this.setState({
      estimateDetails: data,
      currProgress: progr,
      dashboardSelectedTab: selScreen,
      stepItems: filteredTasks,
    });

    this.isEstimateVisible =
      (data?.primaryDebtorName === "Private" &&
        (data.canCancelAuthorityRequest || data.canCancelAuthority)) ||
      !!this.state?.estimateDetails?.trackables?.find((x: any) => {
        return x.id === "9ES";
      });

    if (params["step"] && params["step"] === "estimate") {
      if (this.isEstimateVisible) {
        this.setState({
          dashboardSelectedTab: dashboardTabs.estimateDetails,
        });
      } else {
        this.deleteStepFromURL();
      }
    } else if (params["step"] && params["step"] === "report") {
      if (this.state.report?.is_sent) {
        this.setState({
          dashboardSelectedTab: dashboardTabs.report,
        });
      } else {
        this.deleteStepFromURL();
      }
    }
    this.state.messageBoard.current?.setNotes();

    this.showHideLoader(false);
  };

  deleteStepFromURL() {
    this.commonMethodService.removeSingleQueryParams("step");
    this.setState({
      dashboardSelectedTab: dashboardTabs.home,
      selectedScreen: screens.home,
    });
  }

  setStatusOnHold(productionSummaryId: any, filteredTasks: any) {
    this.ibsService
      .getJobSheet(productionSummaryId)
      .then((jobSheet: JobSheet) => {
        if (jobSheet) {
          if (
            (jobSheet?.onHoldReason && jobSheet?.onHoldReason !== undefined) ||
            (jobSheet?.onHoldUntil && jobSheet?.onHoldUntil !== undefined)
          ) {
            filteredTasks.repair.stepStatus = "onHold";
            filteredTasks.repair.onHoldReason = jobSheet.onHoldReason;
            filteredTasks.repair.onHoldUntil = jobSheet.onHoldUntil;
            this.setState({
              stepItems: filteredTasks,
            });
          }
        }
      });
  }

  getCustomerFromStamped(data: JobEstimationDetail) {
    // this function will be called in flow getter
    this.stampedService.searchCustomer(data.email as any).then((res) => {
      if (res.results.length > 0) {
        this.stampedService.currentCustomerPoints =
          res.results[0].customer.points;
        this.stampedService.availablePoints = res.results[0].points;
        this.stampedService.referralCode = res.results[0].customer.referralCode;
        this.stampedService.customerId = res.results[0].customer.id;
        this.stampedService.referralUrl = res.results[0].customer.referralUrl;
        this.stampedService.currentCustomer = res.results[0].customer;
        this.getMyReferals(res.results[0].customer.referralCode);
        this.setState({
          isOwnerExistInStamped: true,
          isOwnerSubscribedInStamped: res.results[0].customer.isSubscribed,
          isStampedCustomerChecked: true,
        });
        this.stampedService
          .getCustomerRewardData(
            res.results[0].customer.id,
            res.results[0].customer.email
          )
          .then((res: ICustomerRewardDataResp) => {
            this.stampedService.earningPoints = res.campaigns;
            this.setState({
              isOwnerExistInStamped: true,
              isOwnerSubscribedInStamped: this.state.isOwnerSubscribedInStamped,
            });
          });
      } else {
        this.setState({ isStampedCustomerChecked: true });
      }
    });
  }

  logout() {
    this.clearState();
    this.ibsService.logout();
  }

  rewardSendRequest(url: string, method: string, headers: string, data: any) {
    let requestOptions: any = {
      method: method,
      headers: headers,
      //body: JSON.stringify({ title: 'React POST Request Example' })
    };
    if (data) {
      requestOptions["body"] = JSON.stringify(data);
    }
    return fetch(url, requestOptions);
  }

  renderMenuScreen() {
    let buttons = [
      { name: "Home", key: screens.home },
      {
        name: "My Estimate",
        key: dashboardTabs.estimateDetails,
        onClick: (e: any) =>
          this.setState({
            selectedScreen: screens.home,
            dashboardSelectedTab: e.key,
            showMenu: false,
          }),
      },
      {
        name: "Booking Details",
        key: dashboardTabs.bookingDetail,
        onClick: (e: any) =>
          this.setState({
            selectedScreen: screens.home,
            dashboardSelectedTab: e.key,
            showMenu: false,
          }),
      },
      {
        name: "Repair Tracker",
        key: dashboardTabs.repairTracker,
        onClick: (e: any) =>
          this.setState({
            selectedScreen: screens.home,
            dashboardSelectedTab: e.key,
            showMenu: false,
          }),
      },
      { name: "Progress Photos", key: screens.progressPhotos },
      { name: "Contact Us", key: screens.contactUs },
      { name: "Back to Website", key: screens.backToWebsite },
      {
        name: "Change Password",
        key: screens.changePassword,
        onClick: (e: any) => {
          this.setState({
            selectedScreen: e.key,
            showMenu: false,
          });
        },
      },
      { name: "Logout", key: screens.logout },
    ];
    let visibleScreens = [
      screens.home,
      screens.contactUs,
      screens.backToWebsite,
      screens.logout,
    ] as any;

    const user = this.ibsService?.currentUser?.user
      ? this.ibsService?.currentUser?.user
      : this.commonMethodService.getDataFromStorage("currentUser")?.user;

    if (user.is_active) {
      visibleScreens.push(screens.changePassword);
    }

    if (this.state.estimateDetails && this.isEstimateVisible) {
      visibleScreens.push(dashboardTabs.estimateDetails);
    }
    if (
      this.state.estimateDetails &&
      !this.common.isEstimateDeclined(this.state.estimateDetails as any) &&
      this.state.estimateDetails?.jobNumber !== 0
    ) {
      visibleScreens.push(dashboardTabs.bookingDetail);
    }
    if (
      this.state.estimateDetails &&
      this.common.isRepairTrackerActionRequired(
        this.state.estimateDetails as any,
        this.state.currProgress.status as any,
        this.ibsService.isLinkOpenedFromEmail
      )
    ) {
      visibleScreens.push(dashboardTabs.repairTracker);
    }

    const handleMenuButtonClick = (e: any, index: number) => {
      this.setState({ activeButton: index });
      this.setState({ hamburgerColor: "#ffffff" });
      if (e.key == "logout") {
        this.commonMethodService.removeAllQueryParams();
        this.logout();
      } else if (e.onClick) {
        const estimateId = this.state?.estimateDetails?.estimateNumber
          ? this.state?.estimateDetails?.estimateNumber
          : 0;
        if (e.key !== "changePassword") {
          this.commonMethodService.setQueryParams(estimateId, e.key);
        }
        e.onClick(e);
      } else {
        this.commonMethodService.removeAllQueryParams();
        this.setState({
          selectedScreen: e.key,
          showMenu: false,
          dashboardSelectedTab: "",
        });
        if (e.key === "contactUs") {
          this.commonMethodService.setQueryParams(0, e.key);
        }
      }
    };

    buttons = buttons.filter((x) => visibleScreens.indexOf(x.key) > -1);
    return (
      <div
        className="background-overlay"
        onClick={() => this.setState({ showMenu: !this.state.showMenu })}
      >
        <div className="menuBackground">
          <header>
            <strong>Flow Portal</strong>
            <img className="flowLogo" src={_flowLogo} alt="Flow Logo" />
          </header>
          {buttons.map((e, index) => {
            return (
              <button
                key={e.key}
                className={
                  this.state.activeButton === index
                    ? "menuButton active"
                    : "menuButton"
                }
                onClick={() => handleMenuButtonClick(e, index)}
              >
                {e.name}
              </button>
            );
          })}
          ibsService
        </div>
      </div>
    );
  }

  getHeaderText() {
    if (this.state.dashboardSelectedTab == "estimateDetails")
      return "Here's your estimate";
    else if (this.state.dashboardSelectedTab == "bookingDetail")
      return "Let's book your repairs in!";
    return "Welcome to the customer portal";
  }

  getCurrentUserDisplayName() {
    let userName = "";
    if (this.ibsService.currentUser?.user.name === "") {
      return;
    }
    if (this.ibsService.currentUser?.user.name) {
      userName = this.ibsService.currentUser?.user.name;
    } else {
      if (this.state.estimateDetails && this.state.estimateDetails.ownerName) {
        userName = this.state.estimateDetails.ownerName;
      }
    }
    return userName;
  }

  getAdminHeaderText() {
    const estimateData = this.state.estimateDetails || this.commonMethodService.getDataFromStorage("estimateData")
    if (!estimateData) {
      return this.getHeaderText();
    }
    return this.commonMethodService.getAdminHeaderText(estimateData)
  }

  showHideLoader(value: boolean) {
    this.setState({ showLoader: value });
  }

  getImportantMessagesLength() {
    const length = this.state.estimateDetails?.notes?.filter(
      (note: any) =>
        (note.isImportant || note.includedInEstimatePrintout) &&
        !note.isArchived
    ).length;
    return length;
  }

  public async getEstimateData(estimateNumber: string) {
    try {
      let result: JobEstimationDetail =
        await this.ibsAdonisService.getJobEstimateDetailsById(estimateNumber);

      const data = {
        estimateNumber: result?.estimateNumber,
        customer: {
          name: result?.ownerName,
          email: result?.email,
          phone: result?.mobilePhone
        },
        estimateId: result?.estimateId,
        jobNumber: result?.jobNumber || result?.estimateNumber,
        vehicleRegistration: result?.vehicleRegistration,
        createdAt: result?.created
      };
      Mixpanel.track("Get Job", {
        data: data,
        estimateId: estimateNumber,
        status: "Data fetched",
      });
      return data;
    } catch (ex) {
      Mixpanel.track("Get Job Error", {
        error: ex,
        estimateId: estimateNumber,
        status: "Didn't fetched data",
      });
      return null;
    }
  }

  public async getCustomerData(opt: any) {
    let result = await this.apiService
      .getCustomerData({
        externalId: opt.estimateNumber.toString(),
        name: opt.customer?.name,
        email: opt.customer?.email ?? null,
        phone: opt.customer?.phone ?? null,
      })
      .then((result) => result.json());
    const userJob = result.data.user.userJob;
    const previousUserJobs = this.ibsService?.currentUser?.user?.userJob.length;
    if (previousUserJobs) {
      if (userJob.length > previousUserJobs) {
        var currentUser: CurrentUser = this.ibsService.currentUser;
        currentUser.user.userJob = userJob;
        this.commonMethodService.setDataIntoStorage("currentUser", currentUser);
        this.ibsService.currentUser = currentUser;
        this.setState({ currentUserIbsService: this.ibsService });
      }
    }
  }

  searchEstimate(skip = false) {
    if (this.state.isAdmin) {
      this.commonMethodService.removeSingleQueryParams("token")
      if(!skip){
        this.commonMethodService.removeAllQueryParams()
      }
      this.getEstimateDetailsById(false, false, this.state.searchText)
      this.fetchNotesSuggestion();
    }
  }

  renderTheActualScreen() {
    const params = CommonMethodService.params();
    if (params["estimateid"]) {
      const selectedScreen = this.getDefaultScreen();
      this.setState({
        dashboardSelectedTab: selectedScreen.second,
        selectedScreen: selectedScreen.main,
      });
    } else {
      const isAdmin = isAdminLogin()
      if (isAdmin) {
        this.setState({ selectedScreen: screens.home, isAdmin });
        this.commonMethodService.removeAllQueryParams();
      } else {
        this.setState({ selectedScreen: "selectJob" });
        this.commonMethodService.removeAllQueryParams();
      }
    }
  }

  updateEstimateDetails = (data: JobEstimationDetail) => {
    if (data) {
      this.setEstimateDetailData(data, false);
    }
  };

  setPassword() {}

  render() {
    return (
      <Box className="App" bg={"gray.100"}>
        {this.state.showLoader ? (
          <LoaderCommon isLoginLoader={false} loadingText={""} />
        ) : undefined}
        {this.state.selectedScreen === "home" ? (
          <Box bg="blue.800" shadow="lg" className="mobileHeaderBackground">
            <div className="mobileHeader">
              <div className="info">
                <div className="col-md-12  userName">
                  <div className="welcomeMsg ellipsis">
                    Hello, {this.getCurrentUserDisplayName()}!
                  </div>
                  <div className={"ellipsis"}>{this.isAdmin ? `${this.getAdminHeaderText()}` : this.getHeaderText()}</div>
                </div>
                <Hamburger
                  toggled={this.state.showMenu}
                  toggle={() =>
                    this.setState({ showMenu: !this.state.showMenu })
                  }
                  direction="right"
                  rounded
                  color={this.state.hamburgerColor}
                />
                {this.state.showMenu ? this.renderMenuScreen() : undefined}
              </div>
            </div>
          </Box>
        ) : undefined}
        {this.state.selectedScreen === "home" ? (
          <div className={"screenBg"}>
            <div>
              {this.state.isAdmin && (
                <div className="m-2 d-flex justify-content-center align-items-center">
                  <Input
                    onChange={(e) => {
                      this.setState({ searchText: e.target.value });
                    }}
                    onKeyPress={(e: any) => {
                      if (e.key === "Enter" && this.state.searchText) {
                        this.searchEstimate();
                      }
                    }}
                    value={this.state.searchText}
                    placeholder="Enter estimate ID"
                  />
                  <Button
                    colorScheme="blue"
                    disabled={!this.state.searchText}
                    ml={4}
                    onClick={() => {
                      this.searchEstimate();
                    }}
                  >
                    Search
                  </Button>
                </div>
              )}

              {this.renderScreen()}
            </div>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
          </div>
        ) : (
          this.renderScreen()
        )}
        {this.ibsService.currentUser && this.renderChat()}
      </Box>
    );
  }

  renderScreen() {
    const { navigate } = this.props;
    let params = CommonMethodService.params();
    const handleDashboardSelectedTab = (dashboardSelectedTab: string) => {
      this.setState({
        dashboardSelectedTab: dashboardSelectedTab,
      });
    };

    switch (this.state.selectedScreen) {
      case screens.login:
        return (
          <Login
            ibsService={this.ibsService}
            loginSuccess={() => {
              const isAdmin = isAdminLogin();
              this.setState({ isAdmin: isAdmin });
              this.isAdmin = isAdmin
                this.ibsService.loggedIn = true;
                const toBeNavigated =
                  this.state.currentUserIbsService?.currentUser?.hasOwnProperty(
                    "exist"
                  ) && !this.state.currentUserIbsService?.currentUser?.exist;
                if (params["estimateid"]) {
                  this.ibsAdonisService
                    .getJobEstimateDetailsById(params["estimateid"])
                    .then(async (res: any) => {
                      this.commonMethodService.setDataIntoStorage("estimateData", res)
                      this.setState({estimateDetails: res})

                      const checkActionLogs =
                        await this.handleActionLogsAndNavigation(
                          res,
                          params["estimateid"]
                        );
                      if (!checkActionLogs) {
                        const isOnBoardingFlow = res.adminCheckList.some(
                          (checklistItem: string) =>
                            checklistItem.includes(
                              AdminChecklistItems.ONBOARDING_FLOW
                            )
                        );
                        const isBookingFlow = res.adminCheckList.some(
                          (checklistItem: string) =>
                            checklistItem.includes(
                              AdminChecklistItems.BOOKING_FLOW
                            )
                        );
                        if (isOnBoardingFlow && !isBookingFlow) {
                          if (this.state.skipWelcomeFlow) {
                            navigate(
                              `/?estimateid=${params["estimateid"]}&step=${screens.bookingInspection}`,
                              {
                                replace: true,
                              }
                            );
                          } else {
                            navigate(`/${params["estimateid"]}/welcome`, {
                              replace: true,
                            });
                          }
                        }
                      }
                    });
                }

                this.setState({ currentUserIbsService: this.ibsService, searchText: params["estimateid"] || "" });
                this.fetchNotesSuggestion();
                this.getEstimateDetailsById(false, false, null);
                // this.getImages();
                if (toBeNavigated) {
                  this.commonMethodService.removeAllQueryParams();
                  if (this.state.skipWelcomeFlow) {
                    navigate(
                      `/?estimateid=${params["estimateid"]}&step=${screens.bookingInspection}`,
                      {
                        replace: true,
                      }
                    );
                  } else {
                    navigate(`/${params["estimateid"]}/welcome`, {
                      replace: true,
                    });
                  }
                  return;
                }
                this.renderTheActualScreen();
            }}
          />
        );
      case screens.home:
        return this.state.estimateDetails ? this.renderDashboard() : undefined;

      case screens.selectJob:
        return (
          <SelectJob
            ibsService={this.state?.currentUserIbsService}
            key={this.state?.currentUserIbsService?.user?.id | 0}
            navigate={this.props.navigate}
            handleDashboardSelectedTab={handleDashboardSelectedTab}
            selectJob={() => {
              params = CommonMethodService.params();
              this.setState({
                selectedScreen: params["step"] ? params["step"] : "home",
                dashboardSelectedTab: params["step"] ? params["step"] : "home",
              });
              this.ibsService.loggedIn = true;
              this.fetchNotesSuggestion();
              this.getEstimateDetailsById(false, false, null, "selectJob");
              // this.getImages();
            }}
            logout={() => {
              this.commonMethodService.removeAllQueryParams();
              this.clearState();
              this.ibsService.logout();
            }}
          />
        );
      case screens.contactUs:
        return <ContactUs ibsService={this.ibsService} />;
      case screens.changePassword:
        return (
          <SetupPassword
            closeDialog={() => {
              const params = CommonMethodService.params();
              const step: string | undefined = params["step"];
              if (step) {
                if (Object.values(screens).includes(step as screens)) {
                  this.setState({ selectedScreen: step });
                } else if (
                  Object.values(dashboardTabs).includes(step as dashboardTabs)
                ) {
                  this.setState({ selectedScreen: screens.home });
                  this.setState({ dashboardSelectedTab: step });
                }
              } else {
                this.setState({ selectedScreen: screens.home });
                this.setState({ dashboardSelectedTab: dashboardTabs.home });
              }
            }}
            email={this.ibsService.currentUser.user.email}
            name={this.ibsService.currentUser.user.name}
            ibsService={this.ibsService}
            changePassword={true}
          />
        );
      default:
        return <div>Coming soon</div>;
    }
  }

  renderDashboardTab() {
    const handleDashboardSelectedTab = (dashboardSelectedTab: string) => {
      this.setState({
        dashboardSelectedTab: dashboardSelectedTab,
        isBookingDetailCompleted: false,
      });
    };

    const handleBookingCompleted = (isCompleted: boolean) => {
      this.setState({ isBookingDetailCompleted: isCompleted || false });
    };
    switch (this.state.dashboardSelectedTab) {
      case dashboardTabs.estimateDetails:
        return this.state.estimateDetails ? (
          <Estimate
            isOwnerSubscribed={this.state.isOwnerSubscribedInStamped}
            stampedService={this.stampedService}
            isOwnerExistInStamped={this.state.isOwnerExistInStamped}
            estimateAccepted={() => this.getEstimateDetailsById(true, false)}
            estimateDetails={this.state.estimateDetails}
            ibsService={this.ibsService}
            showAmount={this.common.showEstimateAmount(
              this.state.estimateDetails
                ? this.state.estimateDetails.insurerName
                : ""
            )}
            showHideLoader={(value) => this.showHideLoader(value)}
            navigateToScreen={(key) =>
              this.setState({ selectedScreen: key, dashboardSelectedTab: "" })
            }
            navigateToSelectedTab={(key) =>
              this.setState({
                selectedScreen: "home",
                dashboardSelectedTab: key,
              })
            }
            ibsAdonisService={this.ibsAdonisService}
          />
        ) : (
          ""
        );
      case dashboardTabs.bookingDetail:
        return this.state.estimateDetails ? (
          <Booking
            estimateDetails={this.state.estimateDetails}
            updateEstimateDetails={this.updateEstimateDetails}
            isBookingDetailCompleted={this.state.isBookingDetailCompleted}
            handleDashboardSelectedTab={handleDashboardSelectedTab}
            handleBookingCompleted={handleBookingCompleted}
          />
        ) : undefined;

      case dashboardTabs.bookingInspection:
        return this.state.estimateDetails ? (
          <BookInspection
            estimateDetails={this.state.estimateDetails}
            updateEstimateDetails={this.updateEstimateDetails}
            handleDashboardSelectedTab={handleDashboardSelectedTab}
          />
        ) : undefined;

      case dashboardTabs.repairTracker:
        return this.state.estimateDetails ? (
          <RepairTracker
            images={this.state.images}
            estimateDetails={this.state.estimateDetails}
            currProgress={this.state.currProgress}
            ibsService={this.ibsService}
            ibsAdonisService={this.ibsAdonisService}
            stepItems={this.state.stepItems}
            notesSuggestions={this.state.notesSuggestions}
          />
        ) : (
          ""
        );
      case dashboardTabs.estimateFeedback:
        return this.state.estimateDetails ? (
          <EstimateFeedback
            showHideLoader={(value) => this.showHideLoader(value)}
            navigateToScreen={(key) =>
              this.setState({ selectedScreen: key, dashboardSelectedTab: "" })
            }
            estimateDetails={this.state.estimateDetails}
            ibsService={this.ibsService}
          />
        ) : undefined;
      case dashboardTabs.flowGetter:
        return this.state.estimateDetails &&
          this.state.isStampedCustomerChecked ? (
          <FlowGetter
            redeemProducts={this.state.redeemProducts}
            myReferals={this.state.customerReferals}
            UserSubscribedCallback={() =>
              this.getCustomerFromStamped(this.state.estimateDetails as any)
            }
            ibsService={this.ibsService}
            isUserSubscribed={this.state.isOwnerSubscribedInStamped}
            showHideLoader={(value) => this.showHideLoader(value)}
            productRedeemSuccess={() => {
              this.getCustomerFromStamped(this.state.estimateDetails as any);
            }}
            pointsRewarded={(newPoints: number) => {
              this.stampedService.currentCustomerPoints = newPoints;
              this.setState({ showLoader: false });
            }}
            estimateDetails={this.state.estimateDetails as any}
            stampedService={this.stampedService}
            points={
              this.stampedService.currentCustomerPoints
                ? this.stampedService.currentCustomerPoints
                : 0
            }
            owner={this.ibsService.currentUser?.user.name as any}
            referralCode={this.stampedService.referralCode}
          />
        ) : undefined;
      case dashboardTabs.report:
        return <Report report={this.state.report} />;
      default:
        return (
          <>
            <Box>
              <Box mb={6} ml="auto" mr="auto" maxW={"xl"}>
                <div className={"video-frame"}>
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/yKyRhqHCodk"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <div className={"video-frame"}>
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/EBvhn-tJHNY"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <div className={"video-frame"}>
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/0vG-jS7ga4I"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <Button
                  colorScheme="blue"
                  size="lg"
                  w={"100%"}
                  mt={4}
                  onClick={(e) =>
                    window.open(
                      "https://www.youtube.com/channel/UCE2tI1uwSHl2JhRqw_0oLDA",
                      "_blank"
                    )
                  }
                >
                  <AiFillYoutube />
                  <span className="btnText">Watch more</span>
                </Button>
              </Box>
              {this.renderBottomImageButtons()}
              <a href="tel:0733543711">
                <Button colorScheme="cyan" bg={"cyan.300"} w={"100%"} mt={6}>
                  <IoCall />
                  <span className="btnText">Call for assistance</span>
                </Button>
              </a>
            </Box>
          </>
        );
    }
  }

  private renderDashboard() {
    const handleSelectScreen = (screen: string) => {
      this.setState({ selectedScreen: screen });
    };
    const handleSetupPasswordDialog = (isSetupPasswordDialog: boolean) => {
      this.setState({ isSetupPasswordDialog: isSetupPasswordDialog });
    };

    const handleDashboardSelectedTab = (dashboardSelectedTab: string) => {
      this.setState({
        dashboardSelectedTab: dashboardSelectedTab,
        isBookingDetailCompleted: false,
      });
    };

    return (
      <Box
        rounded="lg"
        boxShadow="md"
        maxW={"800px"}
        m={"auto"}
        p={4}
        bg="white"
        border="1px"
        borderColor="gray.200"
      >
        <Dashboard
          isAdmin={this.state.isAdmin}
          screens={screens}
          handleSelectScreen={handleSelectScreen}
          handleSetupPasswordDialog={handleSetupPasswordDialog}
          isSetupPasswordDialog={this.state.isSetupPasswordDialog}
          estimateDetails={this.state.estimateDetails}
          report={this.state.report}
          currProgress={this.state.currProgress}
          dashboardSelectedTab={this.state.dashboardSelectedTab}
          isEstimateVisible={this.isEstimateVisible}
          handleDashboardSelectedTab={handleDashboardSelectedTab}
          ibsAdonisService={this.ibsAdonisService}
          notesSuggestions={this.state.notesSuggestions}
        />
        {this.renderDashboardTab()}
      </Box>
    );
  }

  openLink(link: string) {
    window.open(link, "_blank");
  }

  renderBottomImageButtons() {
    let buttons = [
      {
        name: "Repair Estimate Glossary",
        image: require("./assets/images/repairProcess.png").default,
        additionalClass: "",
        link: "https://flowautobody.com.au/repair-estimate-glossary/",
      },
      {
        name: "5 Long Road Trip Tips",
        image: require("./assets/images/aboutFlow.png").default,
        additionalClass: "colorBlack",
        link: "https://flowautobody.com.au/5-long-road-trip-tips-this-holiday-season/",
      },
      {
        name: "10 Things You Must Know About Collision Repair Service",
        image: require("./assets/images/faq.png").default,
        additionalClass: "",
        link: "https://flowautobody.com.au/things-about-collision-repair-service/",
      },
    ];
    return (
      <SimpleGrid columns={[1, null, 1]} spacing="20px">
        {buttons.map((e) => {
          return (
            <LinkBox maxW="md" m={"auto"} rounded="md" shadow="md" key={e.name}>
              <Box
                className={["imageButton", e.additionalClass].join(" ")}
                key={Math.random().toString()}
              >
                <img src={e.image} alt="Learn More" />
                <LinkOverlay
                  _hover={{
                    color: "inherit",
                    textShadow: "0px 0px 2px black",
                    fontWeight: "500",
                  }}
                  href={e.link}
                  isExternal={true}
                >
                  <Text fontSize={"xl"} className={"text"}>
                    {e.name}
                  </Text>
                </LinkOverlay>
              </Box>
            </LinkBox>
          );
        })}
      </SimpleGrid>
    );
  }

  setChatState(isOpen: boolean) {
    this.setState({ isChatOpen: isOpen });
  }

  renderChat() {
    return (
      <div className="chat">
        <Popover
          placement="top-start"
          onOpen={() => {
            this.getEstimateDetailsById(
              false,
              false,
              undefined,
              undefined,
              false
            );
            this.state.messageBoard.current.chatOpened();
          }}
        >
          <PopoverTrigger>
            <Box
              as={Button}
              colorScheme={"blue"}
              variant={"outline"}
              backgroundColor={"blue.50"}
              size={{ base: "sm", md: "md", lg: "lg" }}
              minWidth={{ base: "6rem", md: "10rem", lg: "12rem" }}
              className={
                this.state.isChatOpen ? "chat__btn expanded" : "chat__btn"
              }
              onMouseEnter={() => this.setChatState(true)}
              onMouseLeave={() => this.setChatState(false)}
              padding={{ base: "2", md: "3", lg: "4" }}
            >
              {this.state?.estimateDetails && (
                <Box
                  display="flex"
                  gap={{ base: "4px", md: "8px" }}
                  alignItems="center"
                  as={Link}
                  position={"relative"}
                >
                  <IoIosChatbubbles fontSize={"x-large"} />
                  {/* <span>Message Us</span> */}
                  {this.state.newMessage && (
                    <div className="newMessage-badge"></div>
                  )}
                </Box>
              )}
              {(this.state.isChatOpen || !this.state.estimateDetails) && (
                <Box
                  as={Link}
                  href="tel:0733543711"
                  onClick={(event) => event.stopPropagation()}
                >
                  <IoCall fontSize={"x-large"} />
                </Box>
              )}
            </Box>
          </PopoverTrigger>
          <PopoverContent
            minWidth={"350px"}
            marginRight={"10px"}
            className="shadow-lg"
          >
            <PopoverArrow />
            <PopoverCloseButton />
            <PopoverHeader>Messages</PopoverHeader>
            <PopoverBody maxHeight={"500px"} display={"flex"}>
              <MessageBoard
                ref={this.state.messageBoard}
                showHideLoader={(value) => this.showHideLoader(value)}
                estimateDetails={this.state.estimateDetails}
                notesAdded={() => this.getEstimateDetailsById(false, false)}
                estimateId={
                  this.state.estimateDetails
                    ? this.state.estimateDetails.estimateId
                    : ""
                }
                estimateNumber={
                  this.state.estimateDetails
                    ? this.state.estimateDetails.estimateNumber
                    : ""
                }
                hideScreen={() => this.setState({ showMessageBoard: false })}
                ibsService={this.ibsService}
                notes={
                  this.state.estimateDetails && this.state.estimateDetails.notes
                    ? this.state.estimateDetails.notes
                    : []
                }
                ibsAdonisService={this.ibsAdonisService}
                notesSuggestions={
                  this.state.notesSuggestions &&
                  this.state.notesSuggestions.length > 0
                    ? this.state.notesSuggestions
                    : []
                }
                newMessage={(hasNewMessage) => {
                  this.setState({ newMessage: hasNewMessage });
                }}
              />
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </div>
    );
  }
}
export default withNavigate(App);
